import { UPDATE_BUTTON_STATES } from '../types';

export const updateButtonState = (state, cId) => ({
  type: UPDATE_BUTTON_STATES,
  buttonState: state,
  cId,
});

export default {
  updateButtonState,
};



// WEBPACK FOOTER //
// ./src/redux/actions/buttonStateByCId.js